module.exports = __webpack_public_path__ + "img/yun.1fff6023.png";